// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2026-01-13T09:44:35Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 *  Generated from cz.marbes.eosp.controller.ConfigController.
 */
export default class ConfigApi {
    /**
     * 
     *
     * @return cz.marbes.eosp.controller.vo.ProfileActionsVO
     */
    static getProfileActions() {
        const uri = serverContextPath + `/api/config/profile-actions`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @return cz.marbes.eosp.controller.vo.GAConfigVO
     */
    static getGoogleAnalyticsConfiguration() {
        const uri = serverContextPath + `/api/config/google-analytics`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}
